export default "__VITE_ASSET__0f45d164__"